<template>
    <div
        class="flex flex-col w-full h-full gap-y-5 p-2 overflow-y-auto mb-12"
        v-if="form"
    >
        <div
            class="w-full"
            v-for="(component, index) in cComponents"
            :key="component"
        >
            <AsyncComponent
                :error="props?.errors[`${component?.props?.name}`] ?? null"
                :path="component.path"
                v-bind="{
                    ...component.props,
                    disabled: disabled,
                    ...props.options,
                }"
                v-model="form[`${component.name}`]"
            />
            <div
                class="text-red-500"
                v-if="props?.errors[`${component.props.name}`] ?? false"
            >
                {{ form.errors[`${component.props.name}`] ?? "" }}
            </div>
        </div>
    </div>
</template>
<script setup>
import AsyncComponent from "@/Components/AsyncComponent.vue";
import {watch} from "vue";
import { ref, onMounted, toRaw } from "vue";

const props = defineProps({
    routeName: String,
    formComponents: Array,
    errors: {
        type: Object,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    options: {
        type: undefined,
        default: undefined,
    },
    request: {
        type: Object,
        default: {},
    },
});

const cComponents = ref(props.formComponents)

const disabled = ref(props.disabled);
const form = ref(null);
function reloadFilter(){
    let filteredNames = props.formComponents.map((item) => item.name);
    if (form.value == null || form.value == {}){
        let data = {};
        for (const key of filteredNames) {
            data[key] = props.request[key] ?? _.get(form.value, key, '');
        }

        for (const key of Object.keys(props.request)) {
            if (!filteredNames.includes(key)) {
                data[key] = props.request[key];
            }
        }
        form.value = data;
    }

    else {
        for (const key of filteredNames) {
            if (props.request[key] !== _.get(form.value, key, ''))
            form.value[key] = props.request[key] ;
        }

        for (const key of Object.keys(props.request)) {
            if (!filteredNames.includes(key)) {
                form.value[key] = props.request[key];
            }
        }
    }


}

watch(() => props.request, (val, old) => {
    let isDifferent = !_.isEqual(toRaw(val), toRaw(old));
    if(isDifferent){
        reloadFilter(val);
    }
})

watch(() => props.formComponents, (val, old) => {
    let isDifferent = !_.isEqual(toRaw(val), toRaw(old));
    if (isDifferent){
        cComponents.value = val;
        reloadFilter();
    }
})

onMounted(() => {
    reloadFilter()
})

defineExpose({
    form,
});
</script>
